import * as R from 'ramda';

let _cacheManager;

export default class CacheManager {
  /**
   * Never instantiate CacheManager directly, use the instance singleton method instead.
   * @hideconstructor
   */
  constructor() {
    this.getDefaults();
  }

  /**
   *
   * @public
   * @returns {CacheManager} - A singleton CacheManager reference
   */
  static instance() {
    if (!_cacheManager) {
      _cacheManager = new CacheManager();
    }
    return _cacheManager;
  }

  /**
   * @public
   * @param {String|Object} cacheKey - The cache item reference, or a path to the cache item
   * @param {int|null} [id] - Optional, ID of item originally fetched by ID
   */
  invalidate(cacheKey, id = null) {
    //
    // Retrieve the cache item
    //
    let cacheItem = null;
    if (R.type(cacheKey) === 'Object') {
      // Client sent a reference to the cache node
      cacheItem = cacheKey;
    } else {
      // Client sent a string path to the cache node
      const path = cacheKey.split('.');
      cacheItem = R.path(path, this);
    }
    if (!cacheItem) {
      return;
    }
    //
    // Delete the cache item
    //
    if (id && cacheItem) {
      // The cache node is a hash of promises
      delete cacheItem[id.toString()];
      return;
    }
    // The cache node is a Promise
    cacheItem = null;
  }

  /**
   *
   * @public
   * @param {string} cacheKey - the hash key to the cache item
   * @param {*} cacheItem - the value to cache
   * @param {int} id - Optional, ID of item originally fetched by ID
   */
  saveToHashedPromise(cacheKey, cacheItem, id) {
    // Make sure this is the correct storage type (not "Promise")
    const isObject = R.type(this[cacheKey]) === 'Object';

    if (isObject) {
      this[cacheKey][id.toString()] = Promise.resolve(cacheItem);
    }
  }

  /**
   * @public
   */
  clearCache() {
    this.getDefaults();
  }

  /**
   * Cache nodes are one of the following:
   * Hash of Promises fetched by ID, the ID is the hash key. Default is an empty object.
   * Promise of a fetched collection. Default is a null.
   * @private
   */
  getDefaults() {
    this.portal = null;
    this.userNotifications = null;
    this.states = null;
    this.provinces = null;

    this.vendor = {};
    this.vendors = null;
    this.vendorName = {};
    this.masterVendors = null;

    // this.products = null;
    this.product = {};
    this.productName = {};
    // this.masterProducts = null;
    this.masterProduct = {};

    this.settings = null;
    this.riskTiers = null;

    this.bcp = {
      network: null,
      schematicSections: null,
    };

    this.em = {
      function: {},
      functionName: {},
      functionVendorName: {},
    };

    this.am = {
      preparationItemCategories: {},
      preparationItems: {},
      preparationItemName: {},
      preparationItemReferenceNumber: {},
      findingCategories: {},
      findings: {},
      findingName: {},
      findingReferenceNumber: {},
      agencyName: {},
    };

    this.pm = {
      policyDocument: null,
      documentSection: {},
    };

    this.reports = {
      reportGroups: null,
      reportFamilies: null,
      scheduledReportSummary: null,
      archivedReportInstances: {},
      archivedReportInstanceSummary: null,
      myReportInstances: {},
      myReportInstanceSummary: null,
      customerReportInstances: {},
      customerReportInstanceSummary: null,
    };

    this.org = {
      customer: null,
    };
  }
}
